export default "__VITE_ASSET___sa8Lg2A__"